import { SearchMetadata } from "@nerdjs/nerd-core";
import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { Email_Entity } from "../../entities/email";
import { local420Api } from "../api/local420Api";

const emailsAdapter = createEntityAdapter<Email_Entity>();
const initialState = emailsAdapter.getInitialState();

export const emailEndpoints = local420Api.injectEndpoints({
  endpoints: (build) => ({
    getEmails: build.query<
      EntityState<Email_Entity>,
      Record<string, unknown> | void
    >({
      query: (args) => {
        return {
          url: `members/me/emails`,
          params: args,
        };
      },
      transformResponse: (responseData: Email_Entity[]) => {
        return emailsAdapter.setAll(initialState, responseData);
      },
      providesTags: ["emails"],
    }),
    getEmail: build.query<Email_Entity, number>({
      query: (id) => `members/me/emails/${id}`,
      providesTags: (result, error, id) => [{ type: "emails", id }],
    }),
    createEmail: build.mutation<Email_Entity, Partial<Email_Entity>>({
      query: (body) => ({
        method: "POST",
        body,
        url: `emails`,
      }),
      invalidatesTags: ["emails"],
    }),
    updateEmail: build.mutation<
      void,
      { id: number; body: Partial<Email_Entity> }
    >({
      query: (args) => ({
        method: "PUT",
        body: args.body,
        url: `emails/${args.id}`,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "emails", id },
        "emails",
      ],
    }),
    forwardEmail: build.mutation<
      void,
      { id: number; body: Partial<Email_Entity> }
    >({
      query: (args) => ({
        method: "PUT",
        body: args.body,
        url: `emails/${args.id}/forward`,
      }),
    }),
    deleteEmail: build.mutation<void, number>({
      query: (id) => ({
        method: "DELETE",
        url: `emails/${id}`,
      }),
      invalidatesTags: ["emails"],
    }),
  }),
});

export const {
  useGetEmailQuery,
  useForwardEmailMutation,
  useLazyGetEmailsQuery,
  useGetEmailsQuery,
  useCreateEmailMutation,
  useDeleteEmailMutation,
  useUpdateEmailMutation,
} = emailEndpoints;

export default emailEndpoints;
